import { logger } from './logger';
import { recordError } from './errorBuffer';
import { reportClientError } from './diagnose';

/**
 * Registriert globale Fehler-Handler für nicht abgefangene Exceptions
 * und Promise-Rejections. Einmaliger Aufruf beim App-Start.
 *
 * Speist neben dem Log-Ringpuffer (`logger`) zusätzlich den `errorBuffer`
 * (letzte 15 Fehler) — das ist die Quelle für `consoleErrors` im
 * Melde-Werkzeug (bug-report).
 */
export function registerGlobalErrorHandlers(): void {
  window.addEventListener('error', (event) => {
    logger.error('error', `Uncaught: ${event.message}`, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
    });
    recordError({
      message: event.message,
      stack: event.error?.stack,
      source: event.filename,
      ts: new Date().toISOString(),
    });
    reportClientError({
      message: event.message || 'Uncaught error',
      stack: event.error?.stack,
      context: { filename: event.filename, lineno: event.lineno, colno: event.colno },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason =
      event.reason instanceof Error
        ? { message: event.reason.message, stack: event.reason.stack }
        : { reason: String(event.reason) };
    logger.error('error', `Unhandled rejection`, reason);
    recordError({
      message: event.reason instanceof Error ? event.reason.message : String(event.reason),
      stack: event.reason instanceof Error ? event.reason.stack : undefined,
      source: 'unhandledrejection',
      ts: new Date().toISOString(),
    });
    reportClientError({
      message:
        event.reason instanceof Error ? event.reason.message : `Unhandled rejection: ${String(event.reason)}`,
      stack: event.reason instanceof Error ? event.reason.stack : undefined,
    });
  });
}
